export default "__VITE_ASSET__FwwJG7Xm__"